var $35da740d59af89ba$exports = {};
/* eslint-disable linebreak-style */ /* eslint-disable quotes */ const $35da740d59af89ba$var$menuBtn = document.querySelector(".header__menu-btn");
const $35da740d59af89ba$var$menuCloseBtn = document.querySelector(".sidemenu__close-btn");
const $35da740d59af89ba$var$menu = document.querySelector(".sidemenu");
$35da740d59af89ba$var$menuBtn.addEventListener("click", ()=>{
    $35da740d59af89ba$var$menu.classList.add("active");
});
$35da740d59af89ba$var$menuCloseBtn.addEventListener("click", ()=>{
    $35da740d59af89ba$var$menu.classList.remove("active");
});


//# sourceMappingURL=index.a783dd3a.js.map
